import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { Router } from '@angular/router';
import { EmailVerificationComponent } from '../email-verification/email-verification.component';
import { DataLayerService } from 'src/app/services/dataLayer/datalayer.service';
import { OtpActionType, OtpRequestPayload } from 'src/app/models/interface/Registration/registration';
import { ContentDialogComponent } from 'src/app/shared/components/dialogs/content-dialog/content-dialog.component';
import { CommonService } from 'src/app/shared/common/common.service';
import { RegistationUtilitiesService } from '../../services/registation-utilities.service';
import { ThankyouService } from 'src/app/shared/common/thankyou.service';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { CamService } from 'src/app/services/camService/cam.service';
import { OtpVerificationDialogComponent } from 'src/app/modules/cam/components/otp-verification-dialog/otp-verification-dialog.component';
import { CryptoService } from 'src/app/services/commonService/crypto.service';
import { Location, NgFor, NgIf, TitleCasePipe } from '@angular/common';
import { TravelerManagement } from 'src/app/services/dataLayer/CAM/traveler-management.service';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { DependentDatalayerService } from 'src/app/services/dataLayer/CAM/dependent.service';
import { jwtDecode } from 'jwt-decode';


@Component({
  selector: 'app-link-account-dialog',
  templateUrl: './link-account-dialog.component.html',
  styleUrls: ['./link-account-dialog.component.scss'],
  imports: [MatIconButton, MatIcon, MatRadioGroup, ReactiveFormsModule, FormsModule, NgFor, MatRadioButton, NgIf, MatProgressSpinner, MatButton, TitleCasePipe]
})
export class LinkAccountDialogComponent implements OnInit {
  fullName: string = '';
  idMatchedProfiles: any[] = [];
  selectedContactId: any;
  selectedProfileItem: any;
  singleProfileVerified: boolean = false;
  singleDocMobileProfileVerified: boolean = false;
  currentMatchType: string = '';
  vUserDataKey: string = '';
  mobileMatchedClaimed: boolean = false;
  method: any;
  authType: string = '';
  ispersonalInfo:any;
  CommonObj: any = {
    idMatchedProfiles: [],
    fursanMatchedProfiles: [],
    mobileMatchedProfiles: [],
    isSubmitting: false
  };

  Loader: any = {
    isSpinner: false,
    isEditableClicked: false,
    isNotMeSpinner: false
  }

  ModalRef!: MatDialogRef<OtpVerificationDialogComponent>;
  phoneNumber: string = '';
  phoneExtension: string = '';
  isSendingOtp: boolean = false;
  private lastOtpChecksum: string | null = null;
  creatorId: any;
  travelerPersonalinfoType:string = '';
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly dialogRef: MatDialogRef<LinkAccountDialogComponent>,
    private readonly route: Router,
    private readonly _MatDialog: MatDialog,
    private readonly _dataLayerService: DataLayerService,
    public readonly _CommonService: CommonService,
    public readonly _RegistationUtilitiesService: RegistationUtilitiesService,
    public readonly ThankyouService: ThankyouService,
    private readonly _ToastrApiService: ToastrApiService,
    private readonly _CamApiService: CamService,
    private readonly crypto: CryptoService,
    private readonly _camService: CamService,
    private readonly _location: Location,
    private readonly travelerDataLayer: TravelerManagement,
    private readonly _DependentDatalayer: DependentDatalayerService
  ) {

    console.log('data--->', data);
    this.method = data?.method;
    this.creatorId = data?.creatorId;
    this.authType = data?.authType;
    this.travelerPersonalinfoType = data?.travelerPersonalinfo;
  }

  ngOnInit(): void {
    if (this.authType == 'Onboard') {
      this._dataLayerService.mathAndMergePopup(
        'Popup_pageview',
        this.idMatchedProfiles?.length,
        this.data?.data?.userType == '0' ? 'Admin' : 'Employee'
      );
      this._DependentDatalayer.linkAccountPopup((this.idMatchedProfiles?.length || 0) + 1, 'popup_pageview');
    }
    else {
      this.travelerDataLayer.linkAccountPopUp('Popup', 'Popup_pageview');
    }
    this.matchAndMergeRule();

    this.phoneNumber = this.data?.data?.mobileNumber || this.data?.data?.phoneNumber || this.data?.data?.phoneNo || '';
    this.phoneExtension = this.data?.data?.countryCode || '';

  }

  onClose() {
    this._dataLayerService.mathAndMergePopup(
      'Close',
      this.idMatchedProfiles?.length,
      this.data?.data?.userType == '0' ? 'Admin' : 'Employee'
    );
    this._DependentDatalayer.linkAccountCTA('Close', 'Close');
    this.dialogRef.close();
  }

  getPreferredEmail(profile: any): string {
    if (!profile?.email?.length) return '';

    return (
      profile.email.find((e: any) => e.emailVerified)?.email ||
      profile.email[0]?.email ||
      ''
    );
  }

  getPreferredMobile(profile: any): string {
    if (!profile?.mobile?.length) return '';

    const formMobile = this.data?.data?.mobileNumber || this.data?.data?.phoneNumber || this.data?.data?.phoneNo || '';
    const formCountryCode = this.data?.data?.countryCode || '';

    if (formMobile) {
      const cleanFormMobile = formMobile.replace(/[^+\d]/g, '');
      const cleanFullFormMobile = (formCountryCode + formMobile).replace(/[^+\d]/g, '');

      const matchedMobile = profile.mobile.find((m: any) => {
        const mob = m.mobile ? m.mobile.replace(/[^+\d]/g, '') : '';
        return mob === cleanFullFormMobile || mob === cleanFormMobile || mob.endsWith(cleanFormMobile);
      });

      if (matchedMobile) {
        return matchedMobile.mobile;
      }
    }

    return (
      profile.mobile.find((m: any) => m.mobileVerified)?.mobile ||
      profile.mobile[0]?.mobile ||
      ''
    );
  }

  getMatchedIdObj(profile: any): any {
    if (!profile?.id?.length) return null;
    if (profile.id.length === 1) return profile.id[0];

    // Try to find the exact ID that was inputted in the form
    const formId = this.data?.data?.identityNumber ||
      this.data?.data?.Passportno ||
      this.data?.data?.documentNo ||
      this.data?.data?.id_number ||
      this.data?.data?.id ||
      this.data?.docDetail?.id ||
      this.data?.docDetail?.documentNumber;

    if (formId) {
      const matched = profile.id.find((item: any) =>
        item?.id?.toLowerCase() === formId.toLowerCase()
      );
      if (matched) {
        return matched;
      }
    }

    // If we can't find a direct match with form input, return the first one as fallback
    return profile.id[0];
  }

  matchAndMergeRule() {

    this.fullName = this.data?.fullName || '';
    const matches = this.data?.matches?.matchedContacts || [];
    this.currentMatchType = this.data?.matches?.identifiers?.matchType;
    this.vUserDataKey = this.data?.matches?.identifiers?.vUserDataKey || null;

    switch (this.currentMatchType) {
      case 'doc':
        this.idMatchedProfiles = matches;
        // this.idMatchedProfiles = matches.filter((p: any) => p?.matchPoints?.ID);

        // ⭐ AUTO-SELECT FIRST PROFILE
        if (this.idMatchedProfiles.length > 0) {
          this.selectedContactId = this.idMatchedProfiles[0].contactId;
          this.selectedProfileItem = this.idMatchedProfiles[0];
        }

        // ⭐ ONLY for DOC
        if (this.idMatchedProfiles.length === 1) {
          const profile = this.idMatchedProfiles[0];
          this.selectedContactId = profile.contactId;

          // check ID verification only
          const matchedIdObj = this.getMatchedIdObj(profile);
          this.singleProfileVerified = !!matchedIdObj?.idVerified;


          //   console.log('DOC Verified Status1:', this.singleProfileVerified);
          // } else {
          //   this.singleProfileVerified = false
          //   console.log('DOC NotVerified Status1:', this.singleProfileVerified);

        }
        break;

      case 'mobile':
        this.mobileMatchedClaimed = this.data?.matches?.identifiers?.mobileClaimAllowed
        this.idMatchedProfiles = matches;

        // ⭐ AUTO-SELECT FIRST PROFILE
        if (this.idMatchedProfiles.length > 0) {
          this.selectedContactId = this.idMatchedProfiles[0].contactId;
          this.selectedProfileItem = this.idMatchedProfiles[0];
        }

        // this.idMatchedProfiles = matches.filter((p: any) => p?.matchPoints?.mobile);
        break;

      case 'docMobile':

        this.mobileMatchedClaimed = this.data?.matches?.identifiers?.mobileClaimAllowed
        this.idMatchedProfiles = matches;

        // ⭐ AUTO-SELECT FIRST PROFILE
        if (this.idMatchedProfiles.length > 0) {
          this.selectedContactId = this.idMatchedProfiles[0].contactId;
          this.selectedProfileItem = this.idMatchedProfiles[0];
        }

        if (this.idMatchedProfiles.length == 1) {
          const profile = this.idMatchedProfiles[0];
          const matchedIdObj = this.getMatchedIdObj(profile);
          this.singleDocMobileProfileVerified = !!matchedIdObj?.idVerified;

        }
        break;

      case 'fursan':
        this.idMatchedProfiles = matches;

        // ⭐ AUTO-SELECT FIRST PROFILE
        if (this.idMatchedProfiles.length > 0) {
          this.selectedContactId = this.idMatchedProfiles[0].contactId;
          this.selectedProfileItem = this.idMatchedProfiles[0];
        }

        else if (this.idMatchedProfiles.length === 1) {
          const profile = this.idMatchedProfiles[0];
          this.selectedContactId = profile.contactId;

          // check ID verification only
          const matchedIdObj = this.getMatchedIdObj(profile);
          this.singleProfileVerified = !!matchedIdObj?.idVerified;


          //   console.log('DOC Verified Status1:', this.singleProfileVerified);
          // } else {
          //   this.singleProfileVerified = false
          //   console.log('DOC NotVerified Status1:', this.singleProfileVerified);

        }


        break


      default:
        this.idMatchedProfiles = [];
    }
  }

  selectedProfile(matched: any) {
    this.selectedProfileItem = matched;
    this.selectedContactId = matched.contactId;
  }


  notMe() {
    this.Loader.isNotMeSpinner = true; // ✅ loader start
    if (this.authType == 'Onboard') {
      this._dataLayerService.mathAndMergePopup('Don’t_link', this.idMatchedProfiles?.length, this.data?.data?.userType == '0' ? 'Admin' : 'Employee');
      this._DependentDatalayer.linkAccountCTA("Don’t_link", "don't link profile");
    }
    else{
      this.travelerDataLayer.linkAccountPopUp("Don’t_link", "No_link");
    }
    
    if (this.method == 'dependentMatch') {
      this.dependentOnboard();
    }
    else {
      switch (this.currentMatchType) {
        case 'doc':
          if (!this.singleProfileVerified) {
            console.log('✅ Create contact - DOC');
            if (this.method == 'dependentMatch') {
              this.dependentOnboard();
            } else if (this.method == 'documentInfoMatch') {
              this.notMeDocumentInfoUpdate()
            } else if (this.method == 'documentInfoAdd') {
              this.notMeDocumentInfoADD()
            }
            else {
              this.createContact();

            }
          }

          if (this.singleProfileVerified) {
            // Call the gtm fucntio with event onboarding_error
            if (this.authType == 'Onboard') {
              this._dataLayerService.onboarding_error('Account already exists', 'Account already exists', this.data?.data?.userType == '0' ? 'Admin' : 'Employee');
            }
            this._MatDialog.open(ContentDialogComponent, {
              data: {
                imageSrc: 'assets/images/illustrations--SomthingWentWrong.svg',
                buttonText: 'Got it',
                description:
                  'Another account already exists with the document ID, You can register with a different document ID ensuring it belongs to you.',
                contentTitle: 'Account already exists',
                showButton: true,
                width: '480px',
                userType: this.data?.data?.userType,
                authType: this.authType,
              }
            });

            this.dialogRef.close();
          }
          break;
        case 'mobile':
          if (this.authType !== 'Onboard') {
            this.travelerDataLayer.linkAccountPopUp('No_link', 'Link_profile');
          }

          // this._dataLayerService.onboarding_error('Account already exists', 'Account already exists', this.data?.data?.userType == '0' ? 'Admin' : 'Employee');


          // Example mobile scenario
          if (!this.mobileMatchedClaimed) {
            this._MatDialog.open(ContentDialogComponent, {
              data: {
                imageSrc: 'assets/images/illustrations--SomthingWentWrong.svg',
                buttonText: 'Got it',
                description: 'Another account already exists with the phone number, You can register with a different phone number.',
                contentTitle: 'Account already exists',
                showButton: true,
                width: '480px',
                authType: this.authType,
              }
            });
            this.dialogRef.close();
          }

          if (this.mobileMatchedClaimed) {
            this.dialogRef.close();
            const payload: OtpRequestPayload = {
              type: 'mobile',
              otpAction: "mobileOrEmailValidation",
              // value: this.data?.data?.mobileNumber ? this.data?.data?.mobileNumber.replace(/[^+\d]/g, '') : this.data?.data?.phoneNo,
              value: this.phoneExtension + (this.data?.data?.mobileNumber || this.data?.data?.phoneNumber) ? (this.data?.data?.mobileNumber || this.data?.data?.phoneNumber)?.replace(/[^+\d]/g, '') : this.data?.data?.phoneNo,
              channel: 'mobile',
              companyId: "SAA",
              b2BId: null,
              b2BUserId: null,
              eventName: "DocumentUpdate",
            };
            console.log('payload for otp ', payload, this.data);
            this._CamApiService.sendOTP(payload).then((res: any) => {
              const checksum = res.data.checksum
              this.Loader.isSpinner = false;
              const dialogRef = this._MatDialog.open(EmailVerificationComponent, {
                data: {
                  data: this.data?.data,
                  PhoneNumber: this.data?.data.mobileNumber || this.data?.data?.phoneNumber,
                  verifyMode: 'sms',
                  otpChecksum: checksum,
                  actionType: OtpActionType.notMe,
                  panelClass: 'custom-passport-dialog',
                  idType: this.data?.idType,
                  isdCode: this.data?.data.countryCode,
                  isELMVerified: this.data?.elmStatus,
                  elmVerificationDate: this.data?.elmVerificationDate,
                  method: this.method,
                  creatorId: this.creatorId,
                  authType: this.authType,
                  flag: 'notme',
                  ciamId: this.data?.ciamID,
                  secondaryContactId: this.data?.secondaryContactID,
                  vUserDataKey: this.vUserDataKey,

                }
              })

            }).catch((error: any) => {

              const apiErrorCode = error?.error?.details?.[0]?.code;
              if (apiErrorCode === 'DUPLICATE_ENTRY') {
                this._ToastrApiService.show('error', 'OTP already sent. Please wait 30 seconds before trying again.')
              }
              this.Loader.isSpinner = false
              this._ToastrApiService.show('error', error?.error?.details?.[0]?.title)
            })
          }
          break;
        case 'docMobile':
          if (this.mobileMatchedClaimed && !this.singleDocMobileProfileVerified) {
            this.dialogRef.close();
            const payload: OtpRequestPayload = {
              type: 'mobile',
              otpAction: "mobileOrEmailValidation",
              value: this.phoneExtension + this.data?.data.mobileNumber.replace(/[^+\d]/g, ''),
              channel: 'mobile',
              companyId: "SAA",
              b2BId: null,
              b2BUserId: null,
              eventName: "DocumentUpdate"
            };

            this._CamApiService.sendOTP(payload).then((res: any) => {
              const checksum = res.data.checksum
              this.Loader.isSpinner = false;

              const dialogRef = this._MatDialog.open(EmailVerificationComponent, {
                data: {
                  data: this.data?.data,
                  PhoneNumber: this.data?.data.mobileNumber,
                  verifyMode: 'sms',
                  otpChecksum: checksum,
                  actionType: OtpActionType.notMe,
                  panelClass: 'custom-passport-dialog',
                  idType: this.data?.idType,
                  isdCode: this.data?.data.countryCode,
                  method: this.method,
                  authType: this.authType,
                  flag: 'notme',
                  ciamId: this.data?.ciamID,
                  secondaryContactId: this.data?.secondaryContactID,
                  isELMVerified: this.data?.elmStatus,
                  elmVerificationDate: this.data?.elmVerificationDate,
                  consentTCPP: this.data?.ConsentTCPP,
                  consentMarketingOffers: this.data?.ConsentMarketing,
                  creatorId: this.creatorId,
                  vUserDataKey: this.vUserDataKey,
                }
              })

            }).catch((error: any) => {

              const apiErrorCode = error?.error?.details?.[0]?.code;
              if (apiErrorCode === 'DUPLICATE_ENTRY') {
                this._ToastrApiService.show('error', 'OTP already sent. Please wait 30 seconds before trying again.')
              }
              this.Loader.isSpinner = false
              this._ToastrApiService.show('error', error?.error?.details?.[0]?.title)
            })

            return
          }

          if (this.mobileMatchedClaimed && this.singleDocMobileProfileVerified) {

            const selectedMob = this.selectedProfileItem?.mobile?.[0]?.mobile;
            const b2bMobile = this.phoneExtension + this.phoneNumber;

            // if (selectedMob === b2bMobile) {

            //   this._MatDialog.open(ContentDialogComponent, {
            //     data: {
            //       imageSrc: 'assets/images/illustrations--SomthingWentWrong.svg',
            //       buttonText: 'Got it',
            //       description: 'This mobile number is already linked to another profile.',
            //       contentTitle: 'Account already exists',
            //       showButton: true,
            //       width: '480px'
            //     }
            //   });

            //   this.dialogRef.close();
            //   return;
            // }

            this._MatDialog.open(ContentDialogComponent, {
              data: {
                imageSrc: 'assets/images/illustrations--SomthingWentWrong.svg',
                buttonText: 'Got it',
                description:
                  'Another account already exists with the document ID, You can register with a different document ID ensuring it belongs to you.',
                contentTitle: 'Account already exists',
                showButton: true,
                width: '480px',
                userType: this.data?.data?.userType,
                authType: this.authType,
              }
            });

            this.dialogRef.close();

          }

          if (!this.mobileMatchedClaimed) {
            if (this.authType == 'Onboard') {
              this._dataLayerService.onboarding_error('Account already exists', 'Account already exists', this.data?.data?.userType == '0' ? 'Admin' : 'Employee');
            }
            this._MatDialog.open(ContentDialogComponent, {
              data: {
                imageSrc: 'assets/images/illustrations--SomthingWentWrong.svg',
                buttonText: 'Got it',
                description:
                  'Another account already exists with the document ID, You can register with a different document ID ensuring it belongs to you.',
                contentTitle: 'Account already exists',
                showButton: true,
                width: '480px',
                userType: this.data?.data?.userType,
                authType: this.authType,
                
              }
            });

            this.dialogRef.close();
            return
          }



          // if ((this.mobileMatchedClaimed && this.singleDocMobileProfileVerified) || (!this.mobileMatchedClaimed && this.singleDocMobileProfileVerified)) {
          //   const selectedMob = this.selectedProfileItem.mobile[0].mobile;
          //   const b2bMobile = this.phoneExtension + this.phoneNumber
          //   if (selectedMob === b2bMobile) {
          //     this._MatDialog.open(ContentDialogComponent, {
          //       data: {
          //         imageSrc: 'assets/images/illustrations--SomthingWentWrong.svg',
          //         buttonText: 'Got it',
          //         description: 'This mobile number is already linked to another profile.',
          //         contentTitle: 'Account already exists',
          //         showButton: true,
          //         width: '480px'
          //       }
          //     });
          //     this.dialogRef.close();
          //     return
          //   }
          // }

          // if ((this.mobileMatchedClaimed && this.singleDocMobileProfileVerified) || (!this.mobileMatchedClaimed && this.singleDocMobileProfileVerified)) {
          //   const selectedMob = this.selectedProfileItem.mobile[0].mobile;
          //   const b2bMobile = this.phoneExtension + this.phoneNumber
          //   if (selectedMob != b2bMobile) {
          //     this._MatDialog.open(ContentDialogComponent, {
          //       data: {
          //         imageSrc: 'assets/images/illustrations--SomthingWentWrong.svg',
          //         buttonText: 'Got it',
          //         description: 'This mobile number is already linked to another profile.',
          //         contentTitle: 'Account already exists',
          //         showButton: true,
          //         width: '480px'
          //       }
          //     });
          //     this.dialogRef.close();
          //     return
          //   }
          // }

          break;


        case 'fursan':
          if (this.authType == 'Onboard') {
            this._dataLayerService.onboarding_error('Account already exists', 'Account already exists', this.data?.data?.userType == '0' ? 'Admin' : 'Employee');
          }
          this._MatDialog.open(ContentDialogComponent, {
            data: {
              imageSrc: 'assets/images/illustrations--SomthingWentWrong.svg',
              buttonText: 'Got it',
              description:
                'Another account already exists with the AlFursan ID, You can register with a different AlFursan ID ensuring it belongs to you.',
              contentTitle: 'Account already exists',
              showButton: true,
              width: '480px',
              userType: this.data?.data?.userType,
              authType: this.authType,
            }
          });

          this.dialogRef.close();

          break

        default:

          console.log('No match type');
        // this.createContact();

      }
    }

  }

  thisIsMe() {
    console.log(this.data.data)
    if (this.authType == 'Onboard') {
      this._dataLayerService.mathAndMergePopup('Link_profile', this.idMatchedProfiles?.length, this.data?.data?.userType == '0' ? 'Admin' : 'Employee');
      this._DependentDatalayer.linkAccountCTA("Link_profile", "Link_profile");
    } else {
      this.travelerDataLayer.linkAccountPopUp('Link_profile', 'Link_profile');
    }
    
    this.selectedProfileItem = this.idMatchedProfiles.find(
      (p) => p.contactId === this.selectedContactId
    );

    const isB2CInLogin = this.data?.loginCustomerTypd?.includes('B2C') ?? false;
    const isB2CInProfile = this.selectedProfileItem?.customerType?.includes('B2C') ?? false;

    if (isB2CInLogin && isB2CInProfile) {
      this._ToastrApiService.show(
        'error',
        'B2C profile cannot be linked with another B2C profile.'
      );
      return;
    }

    if (this.selectedProfileItem.email.length == 0) {
      this._MatDialog.open(ContentDialogComponent, {
        data: {
          imageSrc: 'assets/images/illustrations--SomthingWentWrong.svg',
          buttonText: 'Got it',
          description: 'We are unable to merge your profiles. To continue, please log in to your AlFursan profile using your AlFursanID and add an email address first.',
          contentTitle: 'Unable to Merge',
          showButton: true,
          width: '480px',
          userType: this.data.data?.userType,
          authType: this.authType,
        }
      });
      this.dialogRef.close();
      return
    }

    switch (this.currentMatchType) {
      case 'doc':
        console.log('DOC - This is me');
        this.dialogRef.close();

        const matchedIdObj = this.getMatchedIdObj(this.selectedProfileItem);
        const isIdVerified = !!matchedIdObj?.idVerified;
        let targetFirstName = null;
        let targetLastName = null;
        if (isIdVerified) {
          targetFirstName = this.selectedProfileItem?.firstName || null;
          targetLastName = this.selectedProfileItem?.lastName || null;
        }

        const payload: OtpRequestPayload = {
          type: 'email',
          otpAction: "mobileOrEmailValidation",
          value: this.selectedProfileItem.email[0]?.email?.toLowerCase(),
          channel: 'email',
          companyId: "SAA",
          b2BId: null,
          b2BUserId: null,
          eventName: "DocumentUpdate"
        };

        this._CamApiService.sendOTP(payload).then((res: any) => {
          const checksum = res.data.checksum
          this.Loader.isSpinner = false;
          const dialogRef = this._MatDialog.open(EmailVerificationComponent, {
            data: {
              data: this.data?.data,
              personalDetail: this.data?.docDetail,
              primaryContactID: this.selectedContactId,
              Email: this.selectedProfileItem.email[0]?.email?.toLowerCase(),
              verifyMode: 'email',
              otpChecksum: checksum,
              actionType: OtpActionType.ThisIsMe,
              panelClass: 'custom-passport-dialog',
              idType: this.data?.idType,
              contactId: this.selectedProfileItem.contactId,
              isELMVerified: this.data?.elmStatus || this.data?.isELMVerified,
              elmVerificationDate: this.data?.elmVerificationDate,
              method: this.method,
              authType: this.authType,
              flag: 'thisisme',
              creatorId: this.creatorId,
              vUserDataKey: this.vUserDataKey,
              docname: this.data?.docname,
              consentTCPP: this.data?.ConsentTCPP,
              consentMarketingOffers: this.data?.ConsentMarketing,
              targetFirstName: targetFirstName,
              targetLastName: targetLastName,
            }
          })

        }).catch((error: any) => {

          const apiErrorCode = error?.error?.details?.[0]?.code;
          if (apiErrorCode === 'DUPLICATE_ENTRY') {
            this._ToastrApiService.show('error', 'OTP already sent. Please wait 30 seconds before trying again.')
          }
          this.Loader.isSpinner = false
          this._ToastrApiService.show('error', error?.error?.details?.[0]?.title)
        })

        break;

      case 'mobile':
        if (this.authType !== 'Onboard') {
          this.travelerDataLayer.linkAccountPopUp('Link_profile', 'No_link');
        }
        console.log('MOBILE - This is me');
        console.log('matched mobile ', this.phoneNumber);
        this.dialogRef.close();
        this.sendMobileOtpAndOpenDialog()
        break;

      case 'docMobile':
        console.log('DOC + MOBILE - This is me');
        this.dialogRef.close();


        if (this.mobileMatchedClaimed) {
          this.sendMobileOtpAndOpenDialog()
        }

        if (!this.mobileMatchedClaimed) {
          const selectedMob = this.selectedProfileItem.mobile[0].mobile;
          const b2bMobile = this.phoneExtension + this.phoneNumber

          if (selectedMob === b2bMobile) {
            this.sendMobileOtpAndOpenDialog()
          } else {
            this._MatDialog.open(ContentDialogComponent, {
              data: {
                imageSrc: 'assets/images/illustrations--SomthingWentWrong.svg',
                buttonText: 'Got it',
                description: 'Another account already exists with the mobile number, You can register with a different mobile number ensuring it belongs to you.',
                contentTitle: 'Account already exists',
                showButton: true,
                width: '480px',
                authType: this.authType,
              }
            });
            this.dialogRef.close();
            return
          }

        }
        if (!this.mobileMatchedClaimed && this.singleDocMobileProfileVerified) {
          const selectedMob = this.selectedProfileItem.mobile[0].mobile;
          const b2bMobile = this.phoneExtension + this.phoneNumber
          if (selectedMob != b2bMobile) {
            this._MatDialog.open(ContentDialogComponent, {
              data: {
                imageSrc: 'assets/images/illustrations--SomthingWentWrong.svg',
                buttonText: 'Got it',
                description: 'Another account already exists with the mobile number, You can register with a different mobile number ensuring it belongs to you.',
                contentTitle: 'Account already exists',
                showButton: true,
                width: '480px',
                authType: this.authType,
              }
            });
            this.dialogRef.close();
            return
          }
        }

        break;

      case 'fursan':
        this.dialogRef.close();
        const payload1: OtpRequestPayload = {
          type: 'email',
          otpAction: "mobileOrEmailValidation",
          value: this.selectedProfileItem.email[0]?.email?.toLowerCase(),
          channel: 'email',
          companyId: "SAA",
          b2BId: null,
          b2BUserId: null,
          eventName: "DocumentUpdate"
        };

        this._CamApiService.sendOTP(payload1).then((res: any) => {
          const checksum = res.data.checksum
          this.Loader.isSpinner = false;
          const dialogRef = this._MatDialog.open(EmailVerificationComponent, {
            data: {
              data: this.method === 'personalInfoMobMatch' ? this.data : this.data?.data,
              personalDetail: this.data?.docDetail,
              primaryContactID: this.selectedContactId,
              Email: this.selectedProfileItem.email[0]?.email?.toLowerCase(),
              verifyMode: 'email',
              otpChecksum: checksum,
              actionType: OtpActionType.ThisIsMe,
              panelClass: 'custom-passport-dialog',
              idType: this.data?.idType,
              contactId: this.selectedProfileItem.contactId,
              isELMVerified: this.data?.elmStatus || this.data?.isELMVerified,
              elmVerificationDate: this.data?.elmVerificationDate,
              method: this.method,
              authType: this.authType,
              flag: 'thisisme',
              creatorId: this.creatorId,
              vUserDataKey: this.vUserDataKey,
              docname: this.data?.docname,
              consentTCPP: this.data?.ConsentTCPP,
              consentMarketingOffers: this.data?.ConsentMarketing,
            }
          })

        }).catch((error: any) => {

          const apiErrorCode = error?.error?.details?.[0]?.code;
          if (apiErrorCode === 'DUPLICATE_ENTRY') {
            this._ToastrApiService.show('error', 'OTP already sent. Please wait 30 seconds before trying again.')
          }
          this.Loader.isSpinner = false
          this._ToastrApiService.show('error', error?.error?.details?.[0]?.title)
        })
        break

      default:

        console.warn('Unknown match type');

        this.dialogRef.close();

        break;
    }
  }
  dependentOnboard() {
    const payload = this.data.data;
    this._camService
      .updateDependentProfile(payload)
      .then((res) => {
        if (!res) {
          this._ToastrApiService.show(
            'error',
            'No response received from server.'
          );
          return;
        }
        this.dialogRef.close();
        this.Loader.isNotMeSpinner = false; // ✅ success me band
        this.dialogRef.afterClosed().subscribe(() => {
          this.travelerDataLayer.dependent_addition_success('Success');
          this._DependentDatalayer.addedSuccessfully('Email', 'You have been added as a family member.');
          this.ThankyouService.show({
            heading: 'You have been added as a family member.',
            description: this.creatorId == 0 ? '' : 'Your profile is now submitted for approval.',
            buttonText: 'Go To Login',
            isShowButton: false,
            redirectUrl: '',
          });
          this._ToastrApiService.show(
            'success',
            res.message || 'Dependent Profile Upadated Successfully.'
          );
        })
      })
      .catch((error) => {
        const errorMessage =
          error?.error?.message ||
          error?.message ||
          'Something went wrong while saving the traveler. Please try again later.';

        this._ToastrApiService.show('error', errorMessage);
      });
  }
  // Mask name (Man*****mar)
  maskName(fullName: string): string {
    if (!fullName) return '';
    const clean = fullName.replace(/\s+/g, '');
    if (clean.length <= 6) return clean;
    const start = clean.substring(0, 3);
    const end = clean.substring(clean.length - 3);
    return `${start}${'*'.repeat(clean.length - 6)}${end}`;
  }

  // Mask Email (man****yadav9@gmail.com)
  maskEmail(email: string): string {
    if (!email) return '';

    const [localPart, domain] = email.split('@');

    if (localPart.length <= 3) {
      return localPart + '***@' + domain;
    }

    if (localPart.length <= 5) {
      return localPart.substring(0, 3) + '**@' + domain;
    }

    const start = localPart.substring(0, 3);
    const end = localPart.substring(localPart.length - 2);

    return `${start}${'*'.repeat(localPart.length - 5)}${end}@${domain}`;
  }

  // Mask Generic Number (Mobile, ID, Alfursan)
  // 9876543210 → 98******10
  maskNumber(value: string): string {
    if (!value || value.length <= 4) return value;

    const start = value.substring(0, 3);
    const end = value.substring(value.length - 2);

    return `${start}${'*'.repeat(value.length - 4)}${end}`;
  }


  createContact() {
    const sessionID = localStorage.getItem('session_id');
    const token = localStorage.getItem('access_token');
    const formData = this.data?.data;
    const payload = {
      firstName: formData.firstname,
      lastName: formData.lastname,
      dateOfBirth: this._CommonService.formatDateToYMD(formData.dateOfBirth),
      title: formData.title,
      gender: formData.gender,
      placeOfResidence: formData.residence,
      nationality: formData.Nationality,
      email: formData.email,
      mobile: formData.mobileNumber,
      phoneExtension: formData.countryCode,
      employeeCode: formData.empCode,
      employeeType: formData.userType,
      idNumber: formData.identityNumber,
      // idType: this.data.idType,
      idType: this.data.idType === 'iqama' ? 'Iqama' : this.data.idType === 'nationalID' ? 'National ID' : this.data.idType === 'passport' ? 'Passport' : this.data.idType,
      passportNationality: formData.Nationality,
      designationId: formData.designation,
      departmentId: formData.department ?? null,
      branchId: formData.branch,
      AlFursanId: formData.alfursanID,
      expiryDate: this._CommonService.formatDateToYMD(formData.docExpiary),
      password: formData.password,
      elmVerified: this.data?.elmStatus,
      isELMVerified: this.data?.elmStatus,
      elmVerificationDate: this.data?.elmVerificationDate,
      consentTCPP: this.data?.ConsentTCPP,
      consentMarketingOffers: this.data?.ConsentMarketing,
      consentLinkAccount: false,
      contactId: '',
      // accountId: '4349855f-8ad6-f011-8544-7ced8d4254b4',
      vUserDataKey: this.vUserDataKey,
      accountId: formData.accountID,
      flag: 'CREATE',
      companyId: 'SAA',
      otp: null,
      checksum: null,
      type: 'email',
      value: null,
      otpAction: 'mobileOrEmailValidation',
      Channel: 'email',
      B2BId: null,
      B2BUserId: null,
      eventName: null,
      subagentId: formData.subagentId,
      saUserId: formData.saUserId,
      userGuid: formData.userGuid,
    };

    console.log('payload', payload);

    this.Loader.isEditableClicked = true;

    this._RegistationUtilitiesService
      .createNewContact(token, sessionID, null, payload)
      .subscribe({
        next: (res: any) => {
          console.log(res);
          if (res.status == 'Success') {
            this.dialogRef.close();
            this.Loader.isNotMeSpinner = false; // ✅ success me band
            this.CommonObj.isSubmitting = false;
            this.Loader.isEditableClicked = false;


            this._dataLayerService.otpVerificationSuccessOnboarding(payload?.type, 'Thank you for joining Saudia Business', 'Success', payload?.employeeType == '0' ? 'Admin' : payload?.employeeType == '1' ? 'Travel Arranger' : 'Employee');
            this.dialogRef.afterClosed().subscribe(() => {
              this.ThankyouService.show({
                heading: 'Profile successfully created!',
                // description: 'We will verify your company details within 2 business days. Once approved, you will receive a confirmation email.',
                buttonText: 'Go To Login',
                isShowButton: true,
                redirectUrl: '',
                employeeType: payload?.employeeType
              });
            });

          }

          if (res?.status?.toLowerCase() === 'failure') {
            const errorMsg = res?.message || 'Something went wrong';
            if (this.authType == 'Onboard') {
              this._dataLayerService.otpVerificationErrorOnboarding(payload?.type, errorMsg, this.data?.data?.userType == '0' ? 'Admin' : 'Employee');
            }
          }

        },

        error: (err: any) => {
          console.error('API error:', err);
          this.CommonObj.isSubmitting = false;
          this.Loader.isEditableClicked = false;
          this.Loader.isNotMeSpinner = false;

          let msg = err?.error?.message || 'Something went wrong';
          try {
            const parsedMsg = JSON.parse(err?.error?.message);
            msg = parsedMsg?.details?.[0]?.message?.Message || parsedMsg?.details?.[0]?.message?.message || msg;
            if (parsedMsg?.target) {
              msg = `${parsedMsg?.message} - Target: ${parsedMsg.target}`;
            }
          } catch (e) { }

          this._ToastrApiService.show('error', msg);
          if (this.authType == 'Onboard') {
            this._dataLayerService.onboarding_error('Account already exists', msg, this.data?.data?.userType == '0' ? 'Admin' : 'Employee');
            this._dataLayerService.errors_occured(msg, this.data?.data?.userType == '0' ? 'Admin' : 'Employee');
            this._dataLayerService.otpVerificationErrorOnboarding(payload?.type, msg, this.data?.data?.userType == '0' ? 'Admin' : 'Employee');
          }
        },
      });
  }

  //mobile OTP Vreification (Mobile and Email)

  // Step 1: Mobile OTP
  private async sendMobileOtpAndOpenDialog() {
    this.Loader.isSpinner = false;
    console.log('matched mobile ', this.phoneNumber);
    if (!this.phoneNumber) {
      this._ToastrApiService.show('error', 'Unable to send OTP. Mobile number not found.');
      return;
    }
    try {
      this.isSendingOtp = true;
      const checksum = await this.sendMobileOtp();
      this.isSendingOtp = false;

      this.ModalRef = this._MatDialog.open(OtpVerificationDialogComponent, {
        panelClass: 'custom-popup-gen-link-account-popup',
        data: {
          PhoneNumber: this.phoneNumber,
          isdCode: this.phoneExtension,
          verifyMode: 'mobile',
          step: 1,
          totalSteps: 2,
          otpChecksum: checksum,
          method: this.method,
          flag: 'thisisme',
          ciamId: this.data?.ciamID,
          secondaryContactId: this.data?.secondaryContactID,
          primarycontactID: this.selectedContactId,
          loginCustomerTypd: this.data?.loginCustomerTypd,
          onResend: () => this.resendMobileOtp(),
          onVerify: (otpValue: string, otpChecksum: string) => this.verifyMobileOtp(otpValue, otpChecksum),
          userType: this.data.data?.userType,
          authType: this.authType
        }
      });

      this.ModalRef.afterClosed().subscribe((result: any) => {
        if (result?.verified) {
          // Proceed to Step 2: Email OTP
          this.sendEmailOtpAndOpenDialog();
        }
      });


    } catch (err: any) {
      this.isSendingOtp = false;
      console.error(err);
      this._ToastrApiService.show('error', err?.message || 'Failed to send OTP. Please try again.');
    }
  }

  private async sendMobileOtp(): Promise<string> {
    const payload = this.buildMobileSendOtpPayload();
    const res: any = await this._CamApiService.sendOTP(payload);
    const checksum = res?.data?.checksum as string | undefined;
    if (!checksum) throw new Error('OTP checksum missing from response');
    this.lastOtpChecksum = checksum;
    return checksum;
  }

  private buildMobileSendOtpPayload(): OtpRequestPayload {
    return {
      type: 'mobile',
      otpAction: 'mobileOrEmailValidation',
      value: this.phoneExtension + this.phoneNumber.replace(/[^+\d]/g, ''),
      channel: 'mobile',
      companyId: 'SAA',
      b2BId: null,
      b2BUserId: null,
      eventName: 'EnableCompanyLogin',
    };
  }
  async resendMobileOtp(): Promise<{ success: boolean; message: string; checksum?: string }> {
    try {
      const checksum = await this.sendMobileOtp();
      const message = 'OTP sent successfully.';
      this._ToastrApiService.show('success', message);
      return { success: true, message, checksum };
    } catch (error: any) {
      const message = error?.error?.message || error?.message || 'Failed to resend OTP. Please try again.';
      this._ToastrApiService.show('error', message);
      throw { success: false, message };
    }
  }

  async verifyMobileOtp(otp: string, checksum?: string): Promise<{ success: boolean; message?: string }> {
    const payload = {
      otp,
      checksum: checksum || this.lastOtpChecksum,
      type: 'mobile',
      value: this.phoneExtension + this.phoneNumber,
      otpAction: 'mobileOrEmailValidation',
      channel: 'mobile',
      companyId: 'SAA',
      eventName: 'EnableCompanyLogin',
      b2BId: null,
      b2BUserId: null,
    };

    if (!payload.checksum) {
      const msg = 'OTP checksum missing. Please resend OTP.';
      this._ToastrApiService.show('error', msg);
      throw { success: false, message: msg };
    }

    try {
      const localSessionId = localStorage.getItem('session_id');
      const res: any = await this._CamApiService.VerifyOTP(payload);
      const otpVerified = res?.data?.otpVerified;
      const resSessionId: any = res.data?.secureSessionId ? jwtDecode(res.data.secureSessionId) : null;
      if (otpVerified === true && (localSessionId == resSessionId?.['sessionId'])) {
        const msg = 'OTP verified successfully.';
        this._ToastrApiService.show('success', msg);
        return { success: true, message: msg };
      } else {
        if (this.authType == 'Onboard') {
          this._dataLayerService.otpVerificationErrorOnboarding(
            payload?.type,
            res?.data?.message ||
            res?.message ||
            'You have entered incorrect OTP, try again.',
            this.data?.data?.userType == '0' ? 'Admin' : 'Employee'
          );
        }
        const msg =
          res?.data?.message ||
          res?.message ||
          'You have entered incorrect OTP, try again.';
        this._ToastrApiService.show('error', msg);

        const lowerMsg = msg.toLowerCase();
        if (lowerMsg.includes('otp') && (lowerMsg.includes('incorrect') || lowerMsg.includes('invalid') || lowerMsg.includes('wrong'))) {
          return { success: false, message: 'Invalid OTP' };
        }
        return { success: false };
      }
    } catch (error: any) {
      const apiMessage =
        error?.error?.message ||
        error?.message ||
        'OTP verification failed. Please try again.';

      this._ToastrApiService.show('error', apiMessage);

      const lowerMsg = apiMessage.toLowerCase();
      if (lowerMsg.includes('otp') && (lowerMsg.includes('incorrect') || lowerMsg.includes('invalid') || lowerMsg.includes('wrong'))) {
        return { success: false, message: 'Invalid OTP' };
      }
      return { success: false };
    }
  }

  //Step 2: Email OTP
  private async sendEmailOtpAndOpenDialog() {
    this.Loader.isSpinner = false;
    if (this.isSendingOtp) return;
    const loginEmail = this.getLoginEmail();

    if (!loginEmail) {
      this._ToastrApiService.show('error', 'Unable to send OTP. Login email not found.');
      return;
    }

    try {
      this.isSendingOtp = true;
      const checksum = await this.sendEmailOtp();
      this.isSendingOtp = false;

      this.ModalRef = this._MatDialog.open(OtpVerificationDialogComponent, {
        panelClass: 'custom-popup-gen-link-account-popup',
        data: {
          Email: loginEmail,
          verifyMode: 'email',
          step: 2,
          totalSteps: 2,
          otpChecksum: checksum,
          method: this.method,
          flag: 'thisisme',
          ciamId: this.data?.ciamID,
          secondaryContactID: this.data?.secondaryContactID,
          primarycontactID: this.selectedContactId,
          loginCustomerTypd: this.data?.loginCustomerTypd,
          userType: this.data.data?.userType,
          authType: this.authType,
          onResend: () => this.resendEmailOtp(),
          onVerify: (otpValue: string, otpChecksum: string) => {
            this._CommonService.loaderSubject.next(true);
            if (this.method == 'personalInfoMobMatch') {
              return this.thisIsMePersonalInfoMobileChange(otpValue, otpChecksum);
            } else if (this.method == 'dependentMatch') {
              return this.verifyEmailOTP(otpValue, otpChecksum);
            }
            else if (this.method == 'beforeLoginCIAMmobileMatch') {
              return this.verifyEmailOTPBeforeLogin(otpValue, otpChecksum);
            }
            else {
              return this.thisISMeContactCreate(otpValue, otpChecksum);
            }
          },
        }
      });
      this.ModalRef.afterClosed().subscribe((result: any) => {
        if (result?.verified) {
          // Proceed to Step 2: mobile OTP
          // this.sendMobileOtpAndOpenDialog();
        }
      });
    } catch (err: any) {
      this.isSendingOtp = false;
      console.error(err);
      this._ToastrApiService.show('error', err?.message || 'Failed to send OTP. Please try again.');
    }
  }
  verifyEmailOTP(otp: any, checksum: any) {

    const payload = {
      otp: otp,
      checksum: checksum,
      type: 'email',
      value: this.getLoginEmail(),
      otpAction: 'mobileOrEmailValidation',
      channel: 'email',
      companyId: 'SAA',
      eventName: 'UserDeactivate', // 🔥 important
      b2BId: null,
      b2BUserId: null,
    };

    return this._camService.VerifyOTP(payload).then((res: any) => {
      this._CommonService.loaderSubject.next(false);

      if (res.data?.otpVerified) {
        const localSessionId = localStorage.getItem('session_id');
        const resSessionId: any = res.data?.secureSessionId ? jwtDecode(res.data.secureSessionId) : null;
        if (localSessionId != resSessionId?.['sessionId']) {
          return { success: false, message: 'Session mismatch' };
        }

        this.dialogRef.close();
        this.ModalRef.close();
        this.thisIsMeDependentOnboard();
        return { success: true };
      } else {
        if (this.authType == 'Onboard') {
        this._dataLayerService.otpVerificationErrorOnboarding(
          payload?.type,
          res?.message ||
          'You have entered incorrect OTP, try again.',
          this.data?.data?.userType == '0' ? 'Admin' : 'Employee'
        );
      }
        const msg =
          res?.data?.message ||
          res?.message ||
          'You have entered incorrect OTP, try again.';
        this._ToastrApiService.show('error', msg);

        const lowerMsg = msg.toLowerCase();
        if (lowerMsg.includes('otp') && (lowerMsg.includes('incorrect') || lowerMsg.includes('invalid') || lowerMsg.includes('wrong'))) {
          return { success: false, message: 'Invalid OTP' };
        }
        return { success: false };
      }
    })
      .catch((error: any) => {
        this._CommonService.loaderSubject.next(false);
        if (this.authType == 'Onboard') {
        this._dataLayerService.otpVerificationErrorOnboarding(
          payload?.type,
          error?.error?.message ||
          error?.message ||
          'OTP verification failed. Please try again.',
          this.data?.data?.userType == '0' ? 'Admin' : 'Employee'
        );
      }
        const apiMessage =
          error?.error?.message ||
          error?.message ||
          'OTP verification failed. Please try again.';

        this._ToastrApiService.show('error', apiMessage);

        const lowerMsg = apiMessage.toLowerCase();
        if (lowerMsg.includes('otp') && (lowerMsg.includes('incorrect') || lowerMsg.includes('invalid') || lowerMsg.includes('wrong'))) {
          return { success: false, message: 'Invalid OTP' };
        }
        return { success: false };
      });
  }

  thisIsMeDependentOnboard() {
    const payload = this.data.data;
    payload['additionalRefId'] = this.selectedProfileItem.contactId;
    this._camService
      .updateDependentProfile(payload)
      .then((res) => {
        if (!res) {
          this._ToastrApiService.show(
            'error',
            'No response received from server.'
          );
        }
        this.travelerDataLayer.dependent_addition_success('Success');
        this._DependentDatalayer.addedSuccessfully('Email', 'You have been added as a family member.');
        this.ThankyouService.show({
          heading: 'You have been added as a family member.',
          description: this.creatorId == 0 ? '' : 'Your profile is now submitted for approval.',
          buttonText: 'Go To Login',
          isShowButton: false,
          redirectUrl: '',
        });
        this._CommonService.loaderSubject.next(false);
      })
      .catch((error) => {
        const errorMessage =
          error?.error?.message ||
          error?.message ||
          'Something went wrong while saving the traveler. Please try again later.';

        this._ToastrApiService.show('error', errorMessage);
      });
  }
  verifyEmailOTPBeforeLogin(otp: any, checksum: any) {
    const payload = {
      otp: otp,
      checksum: checksum,
      type: 'email',
      value: this.getLoginEmail(),
      otpAction: 'mobileOrEmailValidation',
      channel: 'email',
      companyId: 'SAA',
      eventName: 'UserDeactivate',
      b2BId: null,
      b2BUserId: null,
    };

    return this._camService.VerifyOTP(payload)
      .then((res: any) => {

        if (res.data?.otpVerified) {
          const localSessionId = localStorage.getItem('session_id');
          const resSessionId: any = res.data?.secureSessionId ? jwtDecode(res.data.secureSessionId) : null;

          if (localSessionId != resSessionId?.['sessionId']) {
            this._CommonService.loaderSubject.next(false);
            return { success: false, message: 'Session mismatch' };
          }

          // Call only the before login flow
          this.beforeLoginCiamMobileOtp();
          return { success: true };
        } else {
          this._CommonService.loaderSubject.next(false);
          const msg =
            res?.data?.message ||
            res?.message ||
            'You have entered incorrect OTP, try again.';

          this._ToastrApiService.show('error', msg);

          const lowerMsg = msg.toLowerCase();
          if (lowerMsg.includes('otp') && (lowerMsg.includes('incorrect') || lowerMsg.includes('invalid') || lowerMsg.includes('wrong'))) {
            return { success: false, message: 'Invalid OTP' };
          }
          return { success: false };
        }
      })
      .catch((error: any) => {
        this._CommonService.loaderSubject.next(false);

        const apiMessage =
          error?.error?.message ||
          error?.message ||
          'OTP verification failed. Please try again.';

        this._ToastrApiService.show('error', apiMessage);

        if (apiMessage.includes('incorrect OTP') || apiMessage.includes('Incorrect OTP') || apiMessage.includes('Invalid OTP') || apiMessage.includes('invalid OTP')) {
          return { success: false, message: 'Invalid OTP' };
        }
        return { success: false };
      });
  }

  private getLoginEmail(): string {
    return this.selectedProfileItem?.email?.[0]?.email?.toLowerCase() || '';
  }

  private getContactID(): string {
    return this.selectedProfileItem.contactId
  }

  private async sendEmailOtp(): Promise<string> {
    const payload = this.buildEmailSendOtpPayload();
    const res: any = await this._CamApiService.sendOTP(payload);
    const checksum = res?.data?.checksum as string | undefined;
    if (!checksum) throw new Error('OTP checksum missing from response');
    this.lastOtpChecksum = checksum;
    return checksum;
  }

  // Called by email dialog for resend
  async resendEmailOtp(): Promise<{ success: boolean; message: string; checksum?: string }> {
    try {
      const checksum = await this.sendEmailOtp();
      const message = 'OTP sent successfully.';
      this._ToastrApiService.show('success', message);
      return { success: true, message, checksum };
    } catch (error: any) {
      const message = error?.error?.message || error?.message || 'Failed to resend OTP. Please try again.';
      this._ToastrApiService.show('error', message);
      throw { success: false, message };
    }
  }

  private buildEmailSendOtpPayload(): OtpRequestPayload {
    const loginEmail = this.getLoginEmail();
    return {
      type: 'email',
      otpAction: 'mobileOrEmailValidation',
      value: loginEmail,
      channel: 'email',
      companyId: 'SAA',
      b2BId: null,
      b2BUserId: null,
      eventName: 'EnableCompanyLogin',
    };
  }

  thisISMeContactCreate(otpValue: string, otpChecksum: string) {

    console.log(this.data);
    const sessionID = localStorage.getItem('session_id');
    const token = localStorage.getItem('access_token');
    const d = this.data.data;

    this._CommonService.loaderSubject.next(true)//for loader

    const payload = {
      firstName: d.firstname,
      lastName: d.lastname,
      dateOfBirth: this._CommonService.formatDateToYMD(d.dateOfBirth),
      title: d.title,
      gender: d.gender,
      placeOfResidence: d.residence,
      nationality: d.Nationality,
      email: d.email,
      mobile: d.mobileNumber,
      phoneExtension: d.countryCode,
      employeeCode: d.empCode,
      employeeType: d.userType,
      idNumber: d.identityNumber,
      // idType: this.data.idType,
      idType: this.data.idType === 'iqama' ? 'Iqama' : this.data.idType === 'nationalID' ? 'National ID' : this.data.idType === 'passport' ? 'Passport' : this.data.idType,
      passportNationality: d.Nationality,
      designationId: d.designation,
      departmentId: d.department ?? null,
      branchId: d.branch,
      AlFursanId: d.alfursanID,
      expiryDate: this._CommonService.formatDateToYMD(d.docExpiary),
      password: d.password,
      elmVerified: this.data.elmStatus,
      isELMVerified: this.data?.elmStatus,
      elmVerificationDate: this.data?.elmStatus ? (this.data?.elmVerificationDate || new Date().toISOString()) : null,
      consentTCPP: this.data.ConsentTCPP,
      consentMarketingOffers: this.data.ConsentMarketing,
      consentLinkAccount: true,
      contactId: this.getContactID(),
      // accountId: '4349855f-8ad6-f011-8544-7ced8d4254b4',
      accountId: d.accountID,
      vUserDataKey: this.vUserDataKey,
      flag: 'CREATE',
      companyId: 'SAA',
      otp: otpValue,
      checksum: otpChecksum,
      type: 'email',
      value: this.getLoginEmail(),
      otpAction: 'mobileOrEmailValidation',
      Channel: 'email',
      B2BId: null,
      B2BUserId: null,
      eventName: this.data.actionType,
      subagentId: d.subagentId,
      saUserId: d.saUserId,
      userGuid: d.userGuid,
    };

    return new Promise<{ success: boolean; message?: string }>((resolve) => {
      this._RegistationUtilitiesService.createNewContact(token, sessionID, null, payload).subscribe({
        next: (res) => {
          console.log(res);
          this._CommonService.loaderSubject.next(false)//for loader

          this.Loader.isSpinner = false;
          this.ModalRef.close();
          this._dataLayerService.otpVerificationSuccessOnboarding(
            payload?.type,
            'Thank you for joining Saudia Business',
            'Success',
            payload?.employeeType == '0' ? 'Admin' : payload?.employeeType == '1' ? 'Travel Arranger' : 'Employee'
          );
          this.ModalRef.afterClosed().subscribe(() => {
            this.ThankyouService.show({
              heading: 'Profile linked successfully!',
              // description: 'We will verify your company details within 2 business days. Once approved, you will receive a confirmation email.',
              buttonText: 'Go To Login',
              redirectUrl: '',
              isShowButton: true,
              employeeType: payload?.employeeType,
              type: payload?.type
            });
          });
          resolve({ success: true });
        },

        error: (err: any) => {
          console.error('API error:', err);
          this._CommonService.loaderSubject.next(false);
          this.Loader.isSpinner = false;

          let msg = err?.error?.message || 'Something went wrong';
          try {
            const parsedMsg = JSON.parse(err?.error?.message);
            msg = parsedMsg?.details?.[0]?.message?.Message || parsedMsg?.details?.[0]?.message?.message || msg;
            if (parsedMsg?.target) {
              msg = `${parsedMsg?.message} - Target: ${parsedMsg?.target}`;
            }
          } catch (e) { }

          if (err?.error?.message === 'Incorrect OTP') {
            if (this.authType == 'Onboard') {
            this._dataLayerService.otpVerificationErrorOnboarding(
              payload?.type,
              err?.error?.message || err?.error,
              this.data?.data?.userType == '0' ? 'Admin' : 'Employee'
            );
          }
            resolve({ success: false, message: 'Invalid OTP' });
          } else {
            this.dialogRef.close();
            this._ToastrApiService.show('error', msg);
            if (this.authType == 'Onboard') {
              this._dataLayerService.otpVerificationErrorOnboarding(payload?.type, msg, this.data?.data?.userType == '0' ? 'Admin' : 'Employee');
              this._dataLayerService.onboarding_error('Account already exists', msg, this.data?.data?.userType == '0' ? 'Admin' : 'Employee');
              this._dataLayerService.errors_occured(msg, this.data?.data?.userType == '0' ? 'Admin' : 'Employee');
            }
            const lowerMsg = msg.toLowerCase();
            if (lowerMsg.includes('otp') && (lowerMsg.includes('incorrect') || lowerMsg.includes('invalid') || lowerMsg.includes('wrong'))) {
              resolve({ success: false, message: 'Invalid OTP' });
            } else {
              resolve({ success: false });
            }
          }
        },
      });
    });
  }


  thisIsMePersonalInfoMobileChange(otpValue: string, otpChecksum: string) {
    console.log(this.selectedProfileItem)
    const accountID = localStorage.getItem('additionalRefNo')
    console.log(this.data)
    const formData = this.data?.data

    const isPhoneDetailsChanged = !!formData?.phoneNumber || !!formData?.countryCode;
    const isEmailFieldChanged = !!formData?.emailAddress;
    const isAlfursanChanged = !!formData?.alfursanID;

    let isEmailChanged: boolean | null = null;
    let isMobileChanged: boolean | null = null;

    if (isEmailFieldChanged || isPhoneDetailsChanged) {
      isEmailChanged = true;
    }

    if (isPhoneDetailsChanged) {
      isMobileChanged = true;
    }

    const payload = {
      saUserid: formData?.saUserid,
      Title: formData?.title,
      UserFirstName: formData?.userFirstName,
      UserLastName: formData?.userLastName,
      UserDOB: formData?.userDOB,
      Gender: formData?.gender,
      EmployeeCode: formData?.employeeCode,
      EmailAddress: formData?.emailAddress,
      countryCode: (isAlfursanChanged && !isPhoneDetailsChanged) ? null : formData?.countryCode,
      PhoneNumber: (isAlfursanChanged && !isPhoneDetailsChanged) ? null : formData?.phoneNumber,
      IsCorpTravelArranger:
        formData?.IsCorpTravelArranger,
      IsProceedToCheckout:
        formData?.isEmpRightsForTrip,
      BlockUserLiveAccess:
        formData?.allowUserLiveAccess,
      ConsentTC: formData?.cocnsentTC,
      ConsentTCPP: formData?.consentTCPP,
      ConsentMarketing: formData?.ConsentMarketing,
      Flag: formData?.flag,
      Guid: formData?.GUID,
      accountID: accountID,
      vUserDataKey: this.vUserDataKey,
      AlFursanId: formData?.alfursanID,
      data: {
        isEmailVerified: isEmailChanged,
        isPhoneVerified: isMobileChanged,
        // ciamId: this.data?.ciamID,
        ciamId: (isEmailChanged === true || isMobileChanged === true) ? this.data?.ciamID : null,
      },
      primaryContactId: this.selectedContactId,
      secondaryContactId: this.data?.secondaryContactID,
      consentMerge: true,
      otp: otpValue,
      checksum: otpChecksum,
      type: 'email',
      value: this.selectedProfileItem?.email?.[0]?.email?.toLowerCase(),
      otpAction: 'mobileOrEmailValidation'
    };


    return this._CamApiService
      .UpdatePersonalInformationDetails(payload)
      .then(($res) => {
        this._CommonService.loaderSubject.next(false);
        // this.travelerManagement.traveler_detail_click('Save');
        if ($res.status == 'Failure') {
          this.dialogRef.close();
          this._ToastrApiService.show('error', $res.message);
          // this.isVerifying = false
          this._CommonService.loaderSubject.next(false);
          return { success: false, message: $res.message };
        }
        if ($res.status == 'Success') {
          this.ModalRef.close();
          this._CommonService.loaderSubject.next(false);
          this._ToastrApiService.show(
            'success', 'Personal Information updated successfully.'
          );
          this._CamApiService.personalInfoUpdateSuccess$.next($res);
          return { success: true };
        }
        return { success: false };
      })
      .catch((error) => {
        this._CommonService.loaderSubject.next(false);
        console.error('Error saving data', error);

        let msg = error?.error?.message || error?.message || 'Something went wrong';

        const lowerMsg = msg.toLowerCase();
        if (lowerMsg.includes('otp') && (lowerMsg.includes('incorrect') || lowerMsg.includes('invalid') || lowerMsg.includes('wrong'))) {
          return { success: false, message: 'Invalid OTP' };
        } else {
          try {
            const parsedMsg = JSON.parse(error?.error?.message);
            msg = parsedMsg?.details?.[0]?.message?.message || parsedMsg?.details?.[0]?.message?.Message || msg;
            if (parsedMsg?.target) {
              msg = `${parsedMsg?.message || msg} - Target: ${parsedMsg?.target}`;
            }
          } catch (e) { }
          this._ToastrApiService.show('error', msg);
          return { success: false };
        }
      });


  }

  notMeDocumentInfoUpdate() {
    console.log(this.data)
    const accountID = localStorage.getItem('additionalRefNo');
    const formData = this.data?.data;
    const ciamID = this.data?.docDetail?.personalInfo?.ciamId;
    const contactID = this.data?.docDetail?.personalInfo?.contactId;
    const id = this.data?.docDetail?.element?.id;
    const userId = sessionStorage.getItem("userId") || "";

    const payload = {
      QueryNo: 3,
      passportID: id,
      passportNationality: formData?.countryControl0,
      countryOfResidence: formData?.placeOfResidence,
      DocumentType: formData?.DocType,
      passportDOB: this._CommonService.formatDateToISOString(formData?.DOB) || null,
      passportCountryCode: formData?.issueCountry || null,
      passportPOI: formData?.passportPOI || null,
      passportValidityStartDate: this._CommonService.formatDateToISOString(formData?.Validfromdate) || null,
      PassportExpiryDate: this._CommonService.formatDateToISOString(formData?.ExpiryDate) || null,
      isPrimary: true,
      passportNumber: formData?.Passportno,
      primaryContactId: null,
      secondaryContactId: contactID || null,
      consentMerge: false,
      accountID: accountID,
      vUserDataKey: this.vUserDataKey,
      ciamId: ciamID || null,
      // email: this.data?.docDetail?.personalInfo?.email || null,
      firstName: this.data?.docDetail?.personalInfo?.firstName,
      lastName: this.data?.docDetail?.personalInfo?.lastName,
      // elmVerified: false,
      isELMVerified: false,
      elmVerificationDate: null,
      otp: null,
      checksum: null,
      type: null,
      value: null,
      otpAction: null,

    }

    this._CamApiService.UpdateDocumentDetails(userId, payload).then(response => {

      this._ToastrApiService.show('success', "Document information updated successfully.");

      setTimeout(() => {
        this.Loader.isSpinner = false;
        this.Loader.isNotMeSpinner = false; // ✅ success me band
        this.dialogRef.close();
        window.location.reload();
      }, 1000);
    }).catch(error => {
      this.Loader.isNotMeSpinner = false;

      let msg = error?.error?.message || error?.message || "Error updating data";
      try {
        const parsedMsg = JSON.parse(error?.error?.message);
        msg = parsedMsg?.details?.[0]?.message?.message || parsedMsg?.details?.[0]?.message?.Message || msg;
        if (parsedMsg?.target) {
          msg = `${parsedMsg?.message || msg} - Target: ${parsedMsg?.target}`;
        }
      } catch (e) { }

      this._ToastrApiService.show('error', msg);
    });
  }


  notMeDocumentInfoADD() {
    console.log(this.data)
    const formData = this.data?.data
    const personalInfo = this.data?.docDetail
    const userId = sessionStorage.getItem("userId") || "";
    const accountID = localStorage.getItem('additionalRefNo');
    const payload = {
      queryNo: 2,
      passportID: 0,
      passportNationality: formData.countryControl0,
      countryOfResidence: formData.placeOfResidence,
      DocumentType: formData.DocType,
      passportNumber: formData.Passportno,
      passportDOB: this.formatDateToISOString(formData.DOB) || null,
      passportCountryCode: formData.issueCountry || null,
      passportPOI: formData.passportPOI || null,
      passportValidityStartDate: formData.Validfromdate ? this.formatDateToISOString(formData.Validfromdate) : null,
      PassportExpiryDate: this.formatDateToISOString(formData.ExpiryDate) || null,
      isPrimary: true,
      // email: personalInfo?.email || null,
      ciamId: personalInfo?.ciamId || null,
      firstName: null,
      lastName: null,
      accountID: accountID,
      vUserDataKey: this.vUserDataKey,
      primaryContactId: null,
      secondaryContactId: personalInfo?.contactId || null,
      consentMerge: false,
      elmVerified: false,
      isELMVerified: false,
      elmVerificationDate: null,
    };
    console.log("Payload",)

    this._CamApiService.UpdateDocumentDetails(userId, payload).then(response => {
      this._ToastrApiService.show('success', "Document information Insert successfully.")
      this._CommonService.formResetTrigger(); //to reset the form
      this.dialogRef.close();
      this.Loader.isNotMeSpinner = false; // ✅ success me band
      this.Loader.isSpinner = false;


    })
      .catch(error => {
        console.error("Error saving data", error);

        let msg = error?.error?.message || error?.message || "Error saving data";
        try {
          const parsedMsg = JSON.parse(error?.error?.message);
          msg = parsedMsg?.details?.[0]?.message?.message || parsedMsg?.details?.[0]?.message?.Message || msg;
          if (parsedMsg?.target) {
            msg = `${parsedMsg?.message || msg} - Target: ${parsedMsg?.target}`;
          }
        } catch (e) { }

        this._ToastrApiService.show('error', msg);
        this._CommonService.formResetTrigger(); //to reset the form
      });
  }

  formatDateToISOString(dateStr: string): string {
    const parts = dateStr.split('/').map(Number);
    if (parts.length !== 3 || parts.some(isNaN)) {
      throw new Error(`Invalid date format: ${dateStr}`);
    }
    let [day, month, year] = parts;
    month = month - 1;
    const date = new Date(year, month, day);
    if (isNaN(date.getTime())) {
      throw new Error(`Invalid date object created from: ${dateStr}`);
    }
    const pad = (num: number) => num.toString().padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
      date.getDate(),
    )}T00:00:00`;
  }

  goToBack() {
    this._location.back();
  }

  beforeLoginCiamMobileOtp() {
    this._CommonService.loaderSubject.next(true);
    const phoneNumber = `${this.phoneExtension}${this.phoneNumber}`;
    const crmId = localStorage.getItem('CRMID') || '';
    const pload = {
      phonenumber: phoneNumber,
      CRMID: crmId
    };
    const userId = localStorage.getItem('CIAMID') || '';

    this._CamApiService.phoneVerifiedCiam(pload, userId).subscribe({
      next: (response: any) => {
        console.log('phoneVerifiedCiam response', response);
        this.updateProfile();

      },
      error: (err: any) => {
        this._CommonService.loaderSubject.next(false);
        console.error('Error creating phoneVerifiedCiam', err);
        this._ToastrApiService.show('error', "Error occured during phoneVerifiedCiam.");
        this.dialogRef.close();
        if (this.ModalRef) {
          this.ModalRef.close();
        }
      }
    });
  }

  updateProfile() {
    const ciamID = localStorage.getItem('CIAMID') || '';
    const crmid = localStorage.getItem('CRMID') || '';
    const flag = 'thisisme';
    const mobileNumber = this.phoneNumber;
    const payload = {
      CRMID: crmid,
      CIAMID: ciamID,
      flag: flag,
      mobileNumber: mobileNumber,
      vUserDataKey: this.vUserDataKey,
      primaryContactId: this.selectedContactId,
      countryCode: this.phoneExtension,
    };

    this._CamApiService.updateProfileMerge(payload).subscribe({
      next: (response: any) => {
        console.log('updateProfileMerge response', response);

        this.ThankyouService.show({
          heading: 'Your mobile successfully updated',
          description: 'You can now login',
          buttonText: 'Login',
          isShowButton: true,
          redirectUrl: '/login-landing'
        });

        this._CommonService.loaderSubject.next(false);

        setTimeout(() => {
          this.dialogRef.close();

          if (this.ModalRef) {
            this.ModalRef.close();
          }
        }, 300);
      },
      error: (err: any) => {
        this._CommonService.loaderSubject.next(false);
        console.error('Error creating updateProfileMerge', err);
        this._ToastrApiService.show('error', 'Error occurred during update profile.');

        setTimeout(() => {
          this.dialogRef.close();

          if (this.ModalRef) {
            this.ModalRef.close();
          }
        }, 300);
      }
    });
  }
}
